import React from 'react';
import { MenuItem, MenuSurface } from './MenuSurface';

export function NoteMenu({ menuRef, menuPosition, handleAction, onCopy, onDuplicate, onDelete }) {
  return (
    <MenuSurface menuRef={menuRef} menuPosition={menuPosition}>
      <MenuItem icon="📋" label="Copy" shortcut="Ctrl+C" onClick={handleAction(onCopy)} />
      <MenuItem icon="⧉" label="Duplicate" shortcut="Ctrl+D" onClick={handleAction(onDuplicate)} />
      <div className="task-node__drag-menu-divider" />
      <MenuItem icon="🗑️" label="Delete" danger onClick={handleAction(onDelete)} />
    </MenuSurface>
  );
}

export function MilestoneMenu({
  menuRef,
  menuPosition,
  handleAction,
  onEditMilestone,
  onCopy,
  onDuplicate,
  onDelete,
}) {
  return (
    <MenuSurface menuRef={menuRef} menuPosition={menuPosition}>
      <MenuItem icon="🚩" label="Edit Milestone" onClick={handleAction(onEditMilestone)} />
      <div className="task-node__drag-menu-divider" />
      <MenuItem icon="📋" label="Copy" shortcut="Ctrl+C" onClick={handleAction(onCopy)} />
      <MenuItem icon="⧉" label="Duplicate" shortcut="Ctrl+D" onClick={handleAction(onDuplicate)} />
      <div className="task-node__drag-menu-divider" />
      <MenuItem icon="🗑️" label="Delete" danger onClick={handleAction(onDelete)} />
    </MenuSurface>
  );
}
